import { withStyles } from '@material-ui/core/styles';
import {pxToRem} from "../../utils/formatFontSize";

const BrandedStyles = withStyles((theme) => ({
    '@global': {
        '.clickableStop':{
            cursor:'pointer'
        },
        '.suggestedStop':{
            '& p':{
                fontWeight:'bold'  
            }
            
        },
        '.backButton':{
            color:theme.palette.error.main,
            borderColor:theme.palette.grey[500_32],
        },
        '.underTitle':{
            fontWeight:600
        },
        '.boxButtonSection':{
            marginTop:'20px',
            [theme.breakpoints.up("sm")]: {
                width:400
            },
            [theme.breakpoints.down("sm")]: {
                width:'100%'
            },
            '& .dividerContainer':{
                marginTop:'20px',
                display:'flex',
                justifyContent: 'center',
                '& .MuiDivider-root':{
                    width:'50%'
                }
            }
        },
        '.miniInfoBox':{
            display:'flex', 
            alignItems: 'center',
            padding:'30px 20px 0 20px',
            '& .MuiSvgIcon-root':{
                color:theme.palette.grey[600],
                width:'20px',
                height:'20px',
                marginRight:'10px'
            },
            '& .MuiTypography-root':{
                color:theme.palette.grey[600],
                fontSize:'12px'
            }
        },
        '.underTitle.centred':{
            marginTop:'20px',
            textAlign:'center', 
            marginBottom:'20px'
        },
        '.smallHighlightText':{
            color:theme.palette.primary.main,
            fontSize:'13px',
            fontWeight:700,
            lineHeight:'20px'
        },
        '.resetButton':{
            color:theme.palette.error.main,
            minWidth:130,
            borderColor:theme.palette.grey[500_32],
        },
        '.headerWarning':{
            marginTop:30,
            marginBottom:30
        },
        '.bookingButton':{
            [theme.breakpoints.up("sm")]: {
                minWidth:400
            },
            [theme.breakpoints.down("sm")]: {
                width:'100%'
            }
        },
        '.summaryButton':{
            [theme.breakpoints.up("sm")]: {
                width:400
            },
            [theme.breakpoints.down("sm")]: {
                width:'100%'
            }
        },
        'helperText':{
            display:'none'
        },
        '.helperTex1t':{
            display:'none'
        },
        '.subTitle':{
            marginBottom:10
        },
        '.topHelperText':{
            fontWeight: 400,
            lineHeight: 1.4,
            fontSize: pxToRem(14)
        },
        '.metaText':{
            color:theme.palette.primary.main,
        },
        '.dateField': {
            [theme.breakpoints.up("sm")]: {
                minWidth:400
            },
            [theme.breakpoints.down("sm")]: {
                width:'100%'
            },
            '& .MuiOutlinedInput-root': {
                '& fieldset': {
                    borderColor: theme.palette.primary.main,
                },
            }
        },
        '.toggleButtonContainer':{
            paddingTop:15,
            paddingBottom:15
        },
        '.standAloneButton':{
            marginTop:40,
            marginBottom:40,
        },
        '.superMegaBigButton':{
          width:230,
          height:230,
          color:theme.palette.primary.main,
            cursor:"pointer",
            borderRadius:10,
            textAlign:"center",
            border: `1px solid ${theme.palette.grey[500_32]}`,

            '&:hover': {
                backgroundColor: theme.palette.action.hover,
                borderColor:theme.palette.primary.main,
                boxShadow: 'none',
                transition: "backgroundColor 2s, borderColor 1s",
            },
          '& svg':{
              fontSize:150
          }
        },
        '.lowButtonContainer':{
            marginTop:40,
            marginBottom:40,
        },
        '.childSelect':{
            cursor:'pointer',
        },
        '.childSelectSelected':{
            cursor:'pointer',
            '& .studentAvatar':{
                color: theme.palette.primary.dark,
                backgroundColor: theme.palette.success.main,
            }
        },
        '.slideTitle':{
            marginBottom:20
        },
        '.legDetails':{
            '& :nth-of-type(1)':{
                marginTop:20,
            },
            marginBottom:20,
            marginLeft:20
        },
        '.summaryTreeTitle':{
            textTransform:'capitalize'
        },
        '.summaryLocationDot':{
            backgroundColor:theme.palette.primary.main,
        },
        '.summaryModeDot':{
            backgroundColor:theme.palette.success.dark,
            borderColor: theme.palette.success.main,
        },
        '.smallDetailsTable':{
            [theme.breakpoints.up("sm")]: {
                '& table': {
                    width: 'max-content'
                },
            },
            '& td:nth-of-type(1)':{
                borderRight:'1px solid rgba(145, 158, 171, 0.24)'
            },
            '& td':{
                paddingTop:4,
                paddingBottom:4
            }
        },
        '.flightDataFlightNo':{
            color:theme.palette.primary.main,
        },
        '.flightDataIcons':{
            marginRight:pxToRem(20),

            lineHeight:1.5,
            color:theme.palette.primary.main,
        },
        '.formContainer-oldRemove':{
            minHeight:500
        },
        '.formContainer':{
            overflow:'visible !important'
        },
        '.boxyAutoComplete':{
            '& .MuiAutocomplete-popper':{
                zIndex: '20000 !important'
            }
        },
        '.boxyAutoCompleteForcedWidth':{
            [theme.breakpoints.up("sm")]: {
                minWidth:500
            },
            [theme.breakpoints.down("sm")]: {
                width:300
            }
        },
        '.umDetails':{
          flexGrow:1,
          borderLeft:'1px solid',
          borderColor:theme.palette.primary.main,
          paddingLeft:20,
          '& .boxStack':{
              display: 'flex',
              alignItems: 'flex-start',
              flexDirection: 'column',
              '& .studentInputRow':{
                  paddingLeft:5
              }
          }
        },
        '.studentSelect':{
          '&:hover':{
              textDecoration:'none'
          }
        },
        '.primaryAirport':{

        },
        '.secondaryAirport':{
            color:theme.palette.primary.light
        },
        '.bookingCancelled':{
            opacity:0.3,
            textDecoration: 'line-through'
        },
        '.forceCaps':{
            '& input':{
                textTransform: 'uppercase'
            }
        },
        '.ghostHeader':{
            color:theme.palette.primary.contrastText,
            '& .releaseButton':{
                marginLeft:10,
                color:theme.palette.primary.contrastText,
                borderColor:theme.palette.primary.contrastText,
            }
        },
        '.toggler':{

        },
        '.unapproved':{
            color: theme.palette.primary.main
        },
        '.partApproved':{
            color: theme.palette.flags.yellow
        },
        '.fullyApproved':{
            color: theme.palette.flags.green
        },
        '.bookingsAvatars':{
            '& .avatarBooked':{
                backgroundColor: theme.palette.success.main,
                color: theme.palette.primary.dark,
            },
            '& .avatarBooked.MuiAvatarGroup-avatar:first-of-type':{
                backgroundColor: theme.palette.success.main,
                color: theme.palette.primary.dark,
            },
            '& .avatarNotBooked':{
                backgroundColor: theme.palette.primary.light,
                color:theme.palette.primary.contrastText,
            },
            '& .avatarNotBooked.MuiAvatarGroup-avatar:first-of-type':{
                backgroundColor: theme.palette.primary.light,
                color:theme.palette.primary.contrastText,
            },
        },
        '.childHasBooked':{
            opacity:0.3,
            cursor:'pointer',
            '&:hover':{
                textDecoration:'none'
            }
        },
        '.footerNavContainer':{
            [theme.breakpoints.up("sm")]: {
                position:'fixed',
                bottom:0,
                left: 0,
                right: 0,
                margin: 'auto',
                width: 'fit-content',
                backgroundColor:'#FFFFFF',
                paddingLeft:'100px',
                paddingRight:'100px',
            },
            '& .footerNav': {
                display: 'flex',
                justifyContent: 'center',
                [theme.breakpoints.up("sm")]: {
                    paddingTop:'20px',
                    paddingBottom:'20px',
                },
                '& .MuiTypography-root': {
                    fontSize: '12px',
                    marginRight: '10px',
                },
                '& .MuiLink-root': {
                    color:theme.palette.grey[800],
                    textDecoration: 'none',
                    marginLeft: '10px',
                    marginRight: '10px',
                    position: 'relative',
                    '&::before': {
                        content: '"|"',
                        marginLeft: '5px',
                        marginRight: '5px',
                        position: 'absolute',
                        left: '-15px'
                    },
                }
            }
        },
        '.hiddenItinerary':{
            display:'none'
        },
        '.routeSelectionContainer':{
            '& .selectedRoute':{
                '& .routeTitle':{
                    fontWeight:'bold'  
                },
                '& .routeSubTitle':{
                    fontWeight:'bold'  
                },
                '& .selectedStop':{
                    backgroundColor:theme.palette.grey[500_32],
                }
            },
            '& .routeUnavailable':{
                '& .routeDetails':{
                    opacity:0.5
                }
            },
            '& .coachStopContainer':{
                display: 'flex',
                justifyContent: 'space-between',
                width:'500px',
                '& .stopDetailsContainer':{
                    minWidth:200
                },
                '& .stopToolsContainer':{
                    paddingLeft:10, 
                    flexShrink:0, 
                    minWidth:'160px'
                }
            },      
        },
        '& .coachRouteMap':{

            '& .leaflet-div-icon':{
                backgroundColor:'transparent',
                border:'none'
            }
        },
        '.mapOuterContainer':{
            [theme.breakpoints.up("md")]: {
                display:'flex',
                flexDirection: 'row-reverse',
                height:'100%',
            },
            [theme.breakpoints.down("md")]: {
                display:'block'
            },
            '& .mapInnerContainer':{
                [theme.breakpoints.up("md")]: {
                    flexGrow:1,
                },
                [theme.breakpoints.down("md")]: {
                    height:400
                },
                [theme.breakpoints.down("sm")]: {
                    height:350
                },
                [theme.breakpoints.down("xs")]: {
                    height:250
                },
                backgroundColor:'#FF0000',
                '& .mapBoxDirectContainer':{
                    width:'100%',
                    height:'100%',
                    '& .mapBox':{
                        width:'100%',
                        height:'100%'
                    }
                },
            },  
            '& .mapInfoBox':{
                minWidth:300,
                backgroundColor:theme.palette.white,
                padding:'40px 40px 40px 40px',
                color:'#000000',
                '& .statusTitle':{
                    textAlign:'left', 
                    fontWeight:700, 
                    fontSize:'24px'
                },
                '& .companyInfo':{
                     fontSize:'12px',
                     '& .value':{
                        fontWeight:600
                     }
                },
                '& .labelCell':{
                    color:'#FFFFFF', 
                    fontWeight:'bold', 
                    textAlign:'right', 
                    fontSize:14, 
                    borderRight:'1px solid #FFFFFF', 
                    padding:'5px 10px 5px 20px', 
                    lineHeight:1.2
                },
                '& .dataCell':{
                    color:'#FFFFFF', 
                    fontSize:14, 
                    padding:'5px 20px 5px 10px', 
                    lineHeight:1.2
                },
                '& .vehicleDetails':{
                    marginTop:'20px',
                    display:'flex',
                    '& .iconBox':{
                        paddingRight:'20px'
                    },
                    '& .driverName':{
                        fontSize:'16px'
                    },
                    '& .vehicleDescription':{
                        fontSize:'12px'
                    },
                    '& .vehicleReg':{
                        marginTop:'5px',
                        backgroundColor:'#FFEB37',
                        fontSize:'14px',
                        fontWeight:700,
                        padding:'5px 10px 5px 10px',
                        display:'inline-block'
                    },
                },
                '& .passengerContainer':{
                    padding:'20px 0 20px 0',
                    '& .passengerInnerItem':{
                        display:'flex'
                    },
                    '& .iconHolder':{
                        '& .MuiSvgIcon-root':{
                            width:'0.9em',
                            height:'0.9em'
                        }
                    },
                    '& .nameDetails':{
                        marginLeft:'10px',
                        '& .houseInfo':{
                            fontSize:'12px'
                        }
                    }
                },
                '& .pickupTime':{
                    marginTop:'20px',
                    marginBottom:'20px',
                    display:'flex',
                    '& .dateBox':{
                        flexGrow:1,
                        padding:'20px 0 0 0'
                    }
                },
                '& .flightDetails':{
                    display:'flex',
                    margin:'0 0 20px 0',
                    '& .detailsContainer':{
                        flexGrow:1,
                        '& .flightHeader':{
                            fontWeight:600
                        },
                        '& .smallText':{
                            margin:'0 0 0 0'
                        },
                    }
                },
                '& .routeBlocks':{
                    marginLeft:'-16px',
                    '& .MuiTimelineDot-root':{
                        background:'none',
                        border:'none',
                        padding:'0 0 0 0',
                        margin:'10px 0 10px 0',
                        '& .MuiSvgIcon-root':{
                            color:'#FD881A', 
                            height:'16px', 
                            width:'16px',
                            margin:'3px'

                        },
                        '& .MuiSvgIcon-root.endIcon':{
                            color:'#FF0000', 
                            height:'22px', 
                            width:'22px',
                            margin:'0'
                        },
                        '& .MuiSvgIcon-root.startIcon':{
                            color:'#4933FF',
                            
                        }
                    },
                    '& .MuiTimelineContent-root':{
                        paddingTop:'10px'
                    }
                },
                '& .trackerTools':{
                    '& .furtherAssistance':{
                        marginTop:'15px',
                        borderTop:'1px solid #CCCCCC',
                        paddingTop:'15px',
                        '& .callHelperText':{

                        }
                    }
                }
            },
        },

    },

}))(() => null);

export default BrandedStyles;